<template>
  <div class="endereco_conjugue col-12 m-0 p-0">
    <div class="endereco_conjugue_header w-100 p-2 my-2"
         :class="{'endereco_conjugue_header_error': error_general}">
      Endereço
      <span v-if="error_general">
        <IconSvg class="icon-error-campo"
                 icon="alert" />
        Há campos incorretos
      </span>
    </div>

    <div class="endereco_conjugue_body">
      <div v-if="propOrdem == 2"
           class="ml-2">
        <span class="custom-control custom-radio custom-control-inline">
          <input id="enderecoGenitorNovo"
                 type="radio"
                 :name="!compareAddressConjuges"
                 :checked="!compareAddressConjuges"
                 :value="true"
                 class="custom-control-input"
                 @keyup.enter="!compareAddressConjuges, resetAddress(true)"
                 @change="resetAddress(true)">
          <label class="custom-control-label"
                 for="enderecoGenitorNovo">Novo endereço</label>
        </span>
        <span class="custom-control custom-radio custom-control-inline">
          <input id="enderecoConjugue1"
                 type="radio"
                 :name="compareAddressConjuges"
                 :checked="compareAddressConjuges"
                 :value="false"
                 class="custom-control-input"
                 @keyup.enter="compareAddressConjuges, sameAddress()"
                 @change="sameAddress()">
          <label class="custom-control-label"
                 for="enderecoConjugue1">Mesmo endereço do Cônjuge 1</label>
        </span>
      </div>

      <button v-if="!Object.values(propEndereco).length"
              class="btn_add_endereco btn btn-sm btn-outline-primary btn-block my-3 mt-0"
              @click="addAddress">
        <icon-svg icon="add"
                  class="icon-add icon--sm mr-1" />
        Adicionar endereço
      </button>

      <div v-else
           class=""
           :class="{'endereco_conjugue_box_error': error_general}">
        <div class="endereco_conjugue_box my-3 p-1">
          <div v-if="!propPessoas[propOrdem - 1 == 0 ? 1 : 0].outra_circunscricao && ['habilitar_casamento', 'editar_habilitacao_casamento'].indexOf(this.$route.name) != -1"
               class="col">
            <div class="mt-1">
              <span class="custom-control custom-switch mr-4">
                <input :id="`endereco_conjugue_${ _uid }_${ propOrdem }`"
                       v-model="pessoa.outra_circunscricao"
                       class="custom-control-input"
                       name="tipo_registro"
                       type="checkbox"
                       @change="changeCincunscricao()">
                <label class="custom-control-label"
                       :for="`endereco_conjugue_${ _uid }_${ propOrdem }`">
                  Cônjuge domiciliado em outra circunscrição?</label>
              </span>
            </div>
          </div>
          <div class="mt-1" />
          <div class="col p-1">
            <div class="d-inline-flex justify-content-between align-items-center w-100">
              <div class="d-inline-flex">
                <div class="endereco_conjugue_box_endereco mx-2">
                  <h3 class="endereco_conjugue_box_title">
                    Endereço completo
                  </h3>
                  <h3 class="endereco_conjugue_box_endereco">
                    {{ propEndereco | Endereco }}
                  </h3>
                </div>
                <div v-if="pais"
                     class="endereco_conjugue_box_endereco mx-2">
                  <h3 class="endereco_conjugue_box_title">
                    País
                  </h3>
                  <h3 class="endereco_conjugue_box_endereco">
                    {{ pais }}
                  </h3>
                </div>
              </div>
              <div class="endereco_conjugue_box_acoes mx-2">
                <button class="btn btn-danger btn-sm mx-2"
                        @click="deleteAddress">
                  Excluir
                </button>
                <button class="btn btn-primary btn-sm"
                        @click="editAddress">
                  Editar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal :id="`enderecoconjugue`"
             :ref="`enderecoconjugue`"
             :hide-header="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc>
      <BoxEndereco
        :prop-mostrar-exterior="true"
        :no-header="true"
        :data="formEndereco"
        @onEnderecoAdd="getAddress" />

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalEditGenitor_footer">
        <button class="btn btn-sm btn-dark mr-2"
                @click="() => { cancel(), closeModal() }">
          Voltar
        </button>
        <button class="btn btn-sm btn-secondary"
                type="submit"
                @click="submitAddress">
          {{ Object.values(propEndereco).length ? "Atualizar" : "Adicionar" }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  /* components */
  import BoxEndereco from "@/components/SofiaRei/BoxEndereco"

  /* services */
  import NacionalidadesService from "@/services/NacionalidadesService"


  export default {
    name: "EnderecoConjugue",
    components: {
      BoxEndereco
    },
    props: {
      propEndereco: { type: Object, default: () => ({}) },
      propCartorio: { type: Object, default: () => ({})} ,
      propPessoas: { type: Array, default: () => ([])} ,
      propCorrecoes: { type: Object, default: () => ({})},
      propOrdem: { type: Number, default: 0},
      propTipo: { type: String, default: () => ('') }
    },
    data () {
      return {
        formEndereco: {
          exterior: false,
          cep: null,
          logradouro: null,
          numero: null,
          complemento: null,
          bairro: null,
          uf: null,
          cidade: null,
          ibge: null,
          atual: true,
          pais: null
        },
        paises: [],
        pais: null,
        error_general: false,
        pessoa: {
          outra_circunscricao: false
        }
      }
    },
    computed: {
      compareAddressConjuges () {
        const toStringify = (endereco) => {
          const newAddress = { ...endereco }
          newAddress.endereco_id && delete newAddress.endereco_id
          newAddress.created_at && delete newAddress.created_at
          newAddress.updated_at && delete newAddress.updated_at
          return JSON.stringify(newAddress)
        }

        const endereco1 = { ...this.propPessoas[0].endereco }
        const endereco2 = { ...this.propEndereco }

        if (!endereco1 || !endereco2) return false

        return toStringify(endereco1) == toStringify(endereco2)
      }
    },
    watch: {
      propEndereco () {
        if (Object.values(this.propEndereco).length) this.formEndereco = {...this.propEndereco}
        else return

        this.pais = this.formEndereco.pais
        if (!this.paises.length) this.loadPaises()
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      },
      propEndereco () {
        this.init()
      }
    },
    mounted () {
      this.pais = this.formEndereco.pais
      if (!this.paises.length) this.loadPaises()
      this.verifyErrorsCarga()
      this.init()
    },
    methods: {
      init () {
        if (this.propPessoas.length > 0 && this.propOrdem) {
          // pegamos a pessoa
          this.pessoa = { ...this.propPessoas[this.propOrdem - 1] }
        }
      },
      sameAddress () {
        const endereco = { ...this.propPessoas[0].endereco }
        endereco.endereco_id && delete endereco.endereco_id
        this.formEndereco = { ...this.propEndereco, ...endereco }
        this.submitAddress()
      },
      resetAddress (newAddress = false) {
        this.formEndereco = {
          exterior: false,
          cep: null,
          logradouro: null,
          numero: null,
          complemento: null,
          bairro: null,
          uf: this.propCartorio.endereco && !newAddress ? this.propCartorio.endereco.uf : null,
          cidade: this.propCartorio.endereco && !newAddress ? this.propCartorio.endereco.cidade : null,
          ibge: this.propCartorio.endereco && !newAddress ? this.propCartorio.endereco.ibge : null,
          atual: true
        }

        if (newAddress) {
          this.$emit('deleteAddress', this.propEndereco)
        }
      },
      addAddress () {
        this.resetAddress()

        this.$root.$emit('bv::show::modal', `enderecoconjugue`)
      },
      async submitAddress () {
        const valid = await this.$validator.validate()

        const {errors: {items}} = this.$validator
        let emptyNumber = false

        if (items && items.length) {
          emptyNumber = !!items.find(item => item.field == 'numero' || item.field == 'codigo_ibge')
        }

        if (!valid || emptyNumber) return

        this.$emit('addAddress', this.formEndereco)
        this.$root.$emit('bv::hide::modal', `enderecoconjugue`)
      },
      getAddress (endereco) {
        this.formEndereco = {...endereco}
      },
      editAddress () {
        this.formEndereco = {...this.propEndereco}
        this.$root.$emit('bv::show::modal', `enderecoconjugue`)
      },
      deleteAddress () {
        this.$emit('deleteAddress', this.propEndereco)
      },
      async loadPaises () {
        this.paises = await NacionalidadesService.searchNacionalidadeByName("")
        this.getPais()
      },
      getPais () {
        if (this.propEndereco) {
          const pais = this.paises.filter(pais => pais.codigo == this.propEndereco.codigo_pais)
          if (pais.length) this.pais = pais[0].nome
        }
      },
      closeModal () {
        // o cancel(), não tira a class "modal-open" de dentro da class do body, mas emitir um evento que escode o modal, aí sim tira
        this.$root.$emit('bv::hide::modal', `enderecoconjugue`)
      },
      verifyErrorsCarga () {
        this.error_general = false

        Object.keys(this.propCorrecoes).forEach(key => {
          const errors = [
            `CÓDIGO IBGE DO MUNICÍPIO DO LOGRADOURO DO CÔNJUGE ${this.propOrdem}`,
            `DOMICÍLIO ESTRANGEIRO DO CÔNJUGE ${this.propOrdem}`
          ]

          if (errors.indexOf(key) != -1) this.error_general = true
        })
      },
      changeCincunscricao () {
        this.$emit('onChangePessoa', this.pessoa)
      }
    }
  }
</script>
<style lang="scss">
  .btn_add_endereco:hover:not(:disabled) > [class*=icon-add] {
    fill: #fff !important;
  }

  .icon-add {
    fill: #1c7af5 !important;
    width: 18px;
    height: 18px;
    transition: fill 0.2s;
  }

  .endereco_conjugue {
    &_header {
      background: #EAEAEA;
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      color: #000000;

      &_error {
        color: #8B0000
      }
    }

    &_box {
      box-shadow: 1px 2px 5px 0 rgba(0, 0, 0, 0.30);
      height: auto;
      min-height: 70px;

      &_title {
        font-family: Roboto;
        font-size: 14px;
        font-weight: normal;
        color: #373a3c;
        text-decoration: underline;
      }

      &_endereco {
        font-family: Roboto;
        font-size: 16px;
        font-weight: 500;
        color: #373a3c;
      }

      &_error {
        border: solid 2px #8B0000;
        border-radius: 2px;
      }
    }
  }
</style>
